import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../utils/Hooks";
import { API_URL } from "../../../utils/Constants";
import {copyOrder} from "../../../store/reducers/OrdersSlice";

interface OrdersTableProps {
}

export const OrdersTable: React.FC<OrdersTableProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const ordersState = useAppSelector(state => state.orders);
    const accessToken = localStorage.getItem('token');
    const [copyingOrderId, setCopyingOrderId] = useState<number | null>(null);

    const [totalProfit, setTotalProfit] = useState(0);
    const [averageProfit, setAverageProfit] = useState(0);
    const [totalSaleSum, setTotalSaleSum] = useState(0);
    const [totalBuySum, setTotalBuySum] = useState(0);

    useEffect(() => {
        let totalProfit = 0;
        let totalSaleSum = 0;
        let totalBuySum = 0;
        let orderCount = 0;

        ordersState.orders.forEach(order => {
            totalProfit += order.profit || 0;
            totalSaleSum += order.sale_sum || 0;
            totalBuySum += order.buy_sum || 0;
            orderCount += 1;

            if (order.children) {
                order.children.forEach(child => {
                    totalProfit += child.profit || 0;
                    totalSaleSum += child.sale_sum || 0;
                    totalBuySum += child.buy_sum || 0;
                    orderCount += 1;
                });
            }
        });

        setTotalProfit(totalProfit);
        setAverageProfit(totalProfit / orderCount);
        setTotalSaleSum(totalSaleSum);
        setTotalBuySum(totalBuySum);
    }, [ordersState.orders]);

    const handleCopy = async (orderId: number) => {
        if (copyingOrderId !== null) {
            return;
        }

        setCopyingOrderId(orderId);

        try {
            const copiedOrder = await dispatch(copyOrder({id: orderId})).unwrap();
            navigate(`/orders/${copiedOrder.order_id}/modify`);
        } catch (error) {
            window.alert('Veo kopeerimine ebaõnnestus.');
        } finally {
            setCopyingOrderId(null);
        }
    };

    return (
        <div>
            <table className="data">
                <thead>
                <tr>
                    <th style={{width: '2%'}}>Nr</th>
                    <th style={{width: '6%'}}>Kuupäev</th>
                    <th style={{width: '1%', fontSize: '10px'}}>CMR</th>
                    <th style={{width: '8%'}}>Klient</th>
                    <th style={{width: '8%'}}>Hankija</th>
                    <th style={{width: '8%'}}>Teenuse liik</th>
                    <th style={{width: '15%'}}>Marsruut</th>
                    <th style={{width: '3%'}}>Ost</th>
                    <th style={{width: '3%'}}>Müük</th>
                    <th style={{width: '3%'}}>Kasum</th>
                    <th style={{width: '5%'}}>Ostuarve</th>
                    <th style={{width: '5%'}}>Müügiarve</th>
                    <th style={{width: '1%'}}>O</th>
                    <th style={{width: '1%'}}>M</th>
                    <th style={{width: '13%'}}>Kommentaar</th>
                    <th style={{width: '13%'}}>Kogus</th>
                    <th style={{width: '20%'}} className="right"></th>
                </tr>
                </thead>
                <tbody>
                {ordersState.orders.map((order, index) => {

                    const route = `${order.loading_country} (${order.loading_cities}) - ${order.unloading_country} (${order.unloading_cities})`;

                    let className = undefined

                    if ( order.reclamation ) {
                        className = 'reclamation';
                    }

                    return (
                        <React.Fragment key={index}>
                            <tr className={className}>
                                <td>{index + 1}</td>
                                <td>{order.order_time}</td>
                                <td>
                                    {order.cmr === 0 && <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                    {order.cmr === 1 && <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                </td>
                                <td>{order?.client?.name}</td>
                                <td>{order?.vendor?.name}</td>
                                <td>{order?.service?.name}</td>
                                <td>{route}</td>
                                <td>{order.buy_sum}</td>
                                <td>{order.sale_sum}</td>
                                <td>{order.profit?.toFixed(2)}</td>
                                <td>{order.buy_invoice}</td>
                                <td>{order.sale_invoice}</td>
                                <td>
                                    {order.buy_paid === 0 &&
                                    <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                    {order.buy_paid === 1 &&
                                    <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                </td>
                                <td>
                                    {order.sale_paid === 0 &&
                                    <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                    {order.sale_paid === 1 &&
                                    <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                </td>
                                <td>{order.comment}</td>
                                <td>{order.amount}</td>
                                <td className="right w150">
                                    <Link to={`/orders/new/${order.id}/parent`} style={{marginLeft: 3, marginRight: 3}}>+
                                        Alarida</Link>
                                    <span>|</span>
                                    <Link to={`/orders/${order.id}/modify`}
                                          style={{marginLeft: 3, marginRight: 3}}>Muuda</Link>
                                    <span>|</span>
                                    <button
                                        type="button"
                                        onClick={() => handleCopy(order.id)}
                                        disabled={copyingOrderId !== null}
                                        title="Kopeeri"
                                        aria-label={`Kopeeri vedu ${order.id}`}
                                        style={{
                                            marginLeft: 3,
                                            marginRight: 3,
                                            padding: 0,
                                            border: 0,
                                            background: 'transparent',
                                            color: 'inherit',
                                            width: 16,
                                            height: 16,
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            verticalAlign: 'middle',
                                        }}
                                    >
                                        <svg
                                            aria-hidden="true"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                                        </svg>
                                    </button>
                                    <span>|</span>
                                    <Link to={`/orders/${order.id}/delete`}
                                          style={{marginLeft: 3, marginRight: 3}}>Kustuta</Link>
                                    <span>|</span>
                                    {!order.smartaccounts_id &&
                                    <Link to={`/orders/${order.id}/invoice`} style={{marginLeft: 3, marginRight: 3}}>Saada
                                      arve</Link>
                                    }
                                    {order.smartaccounts_id &&
                                    <Link to={`${API_URL}orders/${order.id}/download-invoice?token=${accessToken}`}
                                          style={{marginLeft: 3, marginRight: 3}} target={'_blank'}>Arve</Link>
                                    }
                                    <span>|</span>
                                    <Link to={`/inquiries/${order.inquiry_id}/recommended`} style={{marginLeft: 3, marginRight: 3, fontSize: 16}}>⛟</Link>
                                </td>
                            </tr>
                            {order?.children?.map((child, indexChild) => {

                                const route = `${child.loading_country} (${child.loading_cities}) - ${child.unloading_country} (${child.unloading_cities})`;

                                return (
                                    <tr key={`${index}-${indexChild}`}>
                                        <td>{index + 1}.{indexChild + 1}</td>
                                        <td>{child.order_time}</td>
                                        <td>
                                            {child.cmr === 0 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                            {child.cmr === 1 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                        </td>
                                        <td>{child?.client?.name}</td>
                                        <td>{child?.vendor?.name}</td>
                                        <td>{child?.service?.name}</td>
                                        <td>{route}</td>
                                        <td>{child.buy_sum}</td>
                                        <td>{child.sale_sum}</td>
                                        <td>{child.profit?.toFixed(2)}</td>
                                        <td>{child.buy_invoice}</td>
                                        <td>{child.sale_invoice}</td>
                                        <td>
                                            {child.buy_paid === 0 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                            {child.buy_paid === 1 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                        </td>
                                        <td>
                                            {child.sale_paid === 0 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/>}
                                            {child.sale_paid === 1 &&
                                            <img src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/>}
                                        </td>
                                        <td>{child.comment}</td>
                                        <td>{child.amount}</td>
                                        <td className="right w150">
                                            <Link to={`/orders/${child.id}/modify`}
                                                  style={{marginLeft: 3, marginRight: 3}}>Muuda</Link>
                                            <span>|</span>
                                            <Link to={`/orders/${child.id}/delete`}
                                                  style={{marginLeft: 3, marginRight: 3}}>Kustuta</Link>
                                            <span>|</span>
                                            {!child.smartaccounts_id &&
                                            <Link to={`/orders/${child.id}/invoice`} style={{marginLeft: 3, marginRight: 3}}>Saada
                                              arve</Link>
                                            }
                                            {child.smartaccounts_id &&
                                            <Link to={`${API_URL}orders/${child.id}/download-invoice?token=${accessToken}`}
                                                  style={{marginLeft: 3, marginRight: 3}} target={'_blank'}>Arve</Link>
                                            }
                                        </td>
                                    </tr>
                                )
                            })}
                        </React.Fragment>
                    )
                })}
                </tbody>
            </table>

            <br />

            <div>
                Perioodi kasum kokku: <strong>{totalProfit.toFixed(2)}</strong><br />
                Keskmine kasum: <strong>{averageProfit.toFixed(2)}</strong><br />
                Müük kokku: <strong>{totalSaleSum.toFixed(2)}</strong><br />
                Ost kokku: <strong>{totalBuySum.toFixed(2)}</strong>
            </div>
        </div>
    );
}
